import { PROPERTY_GRID_SUBJECT_PROPERTY } from '@aloft/toolkit-shared';

import { FieldPath, useWatch } from 'react-hook-form';

import { PropertyGridForm } from '../../types.ts';
import { EditableField } from '../EditableField.tsx';
import { ReadOnlyField } from '../ReadOnlyField.tsx';
import { PropertyGridFieldProps } from '../types.ts';
import { resolveFieldName } from '../utils.tsx';

/**
 * `basement.totalArea`/`basement.finishedArea` are independent fields, but `basement.type` makes
 * one of them redundant/derived from the other: `totalArea` is disabled (mirrors `finishedArea`)
 * when Type is Finished, and `finishedArea` is disabled (forced to 0) when Type is Unfinished --
 * see normalizeBasementAreas in @aloft/toolkit-shared. The actual value sync happens in
 * BasementTypeField; this only controls whether the cell is editable.
 */
export const BasementAreaField = (props: PropertyGridFieldProps) => {
  const { columnIndex, field, isArv = false, control, getValues } = props;

  const isTotalArea = field.fieldName.endsWith('.totalArea');
  const disablingType = isTotalArea ? 'finished' : 'unfinished';

  const propertyId = getValues(`columns.${columnIndex}.propertyId`);
  const isSubject = propertyId === PROPERTY_GRID_SUBJECT_PROPERTY;
  const { propertyDataFieldName: areaFieldName } = resolveFieldName(
    field.fieldName,
    columnIndex,
    isSubject,
    isArv,
  );
  const typeFieldName = areaFieldName.replace(
    /\.(totalArea|finishedArea)$/,
    '.type',
  ) as FieldPath<PropertyGridForm>;
  const basementType = useWatch({ control, name: typeFieldName });

  if (basementType === disablingType) return <ReadOnlyField {...props} />;
  return <EditableField {...props} />;
};
